import angular from 'angular';
import uiRouter from 'angular-ui-router';
import groupInvoicesComponent from './group-invoices.component';
import dataTable from 'angular-material-data-table';

let groupInvoicesModule = angular.module('group-invoices', [
    uiRouter,
    dataTable
])
.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('groupInvoices', {
        url: '/group-invoices',
        component: 'groupInvoices',
        parent: 'main',
        data: {
            permissions: {
                only: ['OPERATOR'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('groupInvoices', groupInvoicesComponent)
.name;

export default groupInvoicesModule;
